export const isPreRender = () => navigator.userAgent === 'ReactSnap';
export const IS_PRE_RENDER = isPreRender();
